import React from "react";
import { getGallerie } from "../../actions/gallerie";
import { connect } from "react-redux";
import { tempAlWait } from "../../helpers";
import { faBars, faPlus } from "@fortawesome/free-solid-svg-icons";
import Alert from "../../components/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import AdminHeader from "../../components/AdminHeader";
import AdminItemGallerie from "../../components/AdminItemGallerie";

class AdminGallerie extends React.Component {
    state = {
        menuActive: false,
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        opts: [
            {
                type: 'link',
                ttl: "Ajouter une image",
                ico: faPlus,
                link: "/admin/galerie/ajout",
                action: null,
                col: null
            }
        ],
        datas: []
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.props.getGallerie();
            this.setState({
                alert: tempAlWait()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.getGallerie();
                this.setState({
                    alert: tempAlWait()
                });
            }
        }

        if (prevProps.redGetGall != this.props.redGetGall) {
            this.setState({
                alert: this.props.redGetGall.alert,
                datas: this.props.redGetGall.datas
            })
        }
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="La galerie"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {
                    this.state.datas.length == 0 ?
                        <h2 className="admin__empty">Aucune image n'a été ajoutée pour le moment.</h2> :
                        <ul className="admin__list">
                            {
                                this.state.datas.map((data, key) => {
                                    return <AdminItemGallerie
                                        data={data}
                                        key={`gallerie-${key}`}
                                        changeAlert={(alert) => {this.setState({alert: alert})}}
                                        refreshList={(doRefresh) => {
                                            if (doRefresh) {
                                                this.props.getGallerie();
                                            }
                                        }}
                                    />
                                })
                            }
                        </ul>
                }
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redGetGall: state.redGetGall
    }
}

const mapDispatchToProps = {
    getGallerie
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminGallerie);